import { asNumber, asObjectValue, loadedDefinedMap } from "common/components/component-helpers";
import { Data } from "common/components/data";
import { ActionSource, AppEnvironment, AppOther } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useWeather } from "hooks/use-weather";
import * as React from "react";
import { Weather } from "webapp/ui/smart/weather/weather";

export const WeatherMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[locationValue, onTap, hideCityValue]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClickWithCustomContext: onClickCB } = useOnClickFromAction(onTap, ActionSource.None, ctx, env);

    const location = loadedDefinedMap(locationValue, asObjectValue);
    const latitudeValue = location === undefined ? undefined : force(location.latitude);
    const latitude = loadedDefinedMap(latitudeValue, asNumber);
    const longitudeValue = location === undefined ? undefined : force(location.longitude);
    const longitude = loadedDefinedMap(longitudeValue, asNumber);
    const weather = useWeather(latitude, longitude);

    if (location === undefined || latitude === undefined || longitude === undefined) {
        return null;
    }

    const onClick =
        onClickCB !== undefined
            ? () => {
                  return onClickCB(
                      Data.fromJSON<AppOther, AppEnvironment>({ latitude, longitude }),
                      undefined
                  );
              }
            : undefined;

    const hideCity = hideCityValue === true;

    return <Weather hideCity={hideCity} onClick={onClick} weather={weather} />;
};
